// extracted by mini-css-extract-plugin
export default {"cta":"YG-z","disabled":"ZG-z"};